import React, { memo } from 'react';
import cn from 'classnames';

import tabsStyles from '@dealroadshow/uikit/core/styles/tabs.scss';

interface ITab {
  name: string,
  key: string | number,
  isDisabled: boolean,
}

interface ITabsProps<T extends ITab> {
  tabs: T[],
  onSelect: (name: string) => void,
  dataTest: string,
  activeTab?: string,
  className?: string,
}

const Tabs = ({ tabs, activeTab = '', onSelect, dataTest, className }: ITabsProps<ITab>) => (
  <>
    { tabs.map((tab: ITab) => (
      <span
        key={ tab.key }
        data-test={ dataTest }
        onClick={ () => !tab.isDisabled && onSelect(tab.name) }
        className={ cn(tabsStyles.tab, className, {
          [tabsStyles.isTabActive]: activeTab === tab.key,
          [tabsStyles.isTabDisabled]: tab.isDisabled || false,
        }) }
      >
        <span>{ tab.name }</span>
      </span>
    )) }
  </>
);

export default memo(Tabs);
